// extracted by mini-css-extract-plugin
export var animateCircle = "footer-module--animate-circle--1cxND";
export var bounce = "footer-module--bounce--UVh9-";
export var button = "footer-module--button--WUUgQ";
export var container = "footer-module--container--kJLYY";
export var data = "footer-module--data--11Kj1";
export var dataInfo = "footer-module--dataInfo--agbA7";
export var footer = "footer-module--footer--bC6Wz";
export var ldsRing = "footer-module--lds-ring--guukT";
export var links = "footer-module--links--qIPvC";
export var linksData = "footer-module--linksData--idK3M";
export var linksItem = "footer-module--linksItem--D+Zv2";
export var linksSoc = "footer-module--linksSoc--WVK0-";
export var linksSocial = "footer-module--linksSocial--DxmYJ";
export var terms = "footer-module--terms--BfOi7";
export var termsLinks = "footer-module--termsLinks--F8-AC";
export var termsRules = "footer-module--termsRules--UEVzP";
export var title = "footer-module--title--+fviF";